/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    aws_project_region: "us-west-2",
    aws_cloud_logic_custom: [
      {
        name: "resendFunc",
        endpoint: "https://xmhi640uv8.execute-api.us-west-2.amazonaws.com/dev",
        region: "us-west-2",
      },
      {
        name: "payStripe",
        endpoint: "https://mbm108fe7g.execute-api.us-west-2.amazonaws.com/dev",
        region: "us-west-2",
      },
      {
        name: "doorControl",
        endpoint: "https://y1fi0g4cqh.execute-api.us-west-2.amazonaws.com/dev",
        region: "us-west-2",
      },
      {
        name: "verifyStripe",
        endpoint: "https://kxxeahsgyf.execute-api.us-west-2.amazonaws.com/dev",
        region: "us-west-2",
      },
    ],
    aws_appsync_graphqlEndpoint:
      "https://zeffyv34prd6jpodkznlwqnbpu.appsync-api.us-west-2.amazonaws.com/graphql",
    aws_appsync_region: "us-west-2",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_appsync_apiKey: "da2-esc3p5st2nfyflqrrhhs265u7e",
    aws_cognito_identity_pool_id:
      "us-west-2:c0d4602a-8d30-44f2-8ac2-991052826854",
    aws_cognito_region: "us-west-2",
    aws_user_pools_id: "us-west-2_3kXgysI99",
    aws_user_pools_web_client_id: "1pblbr8nkptffgeeir63c6f07l",
    oauth: {},
    aws_cognito_username_attributes: ["EMAIL"],
    aws_cognito_social_providers: [],
    aws_cognito_signup_attributes: [],
    aws_cognito_mfa_configuration: "OFF",
    aws_cognito_mfa_types: ["SMS"],
    aws_cognito_password_protection_settings: {
      passwordPolicyMinLength: 8,
      passwordPolicyCharacters: [
        "REQUIRES_LOWERCASE",
        "REQUIRES_NUMBERS",
        "REQUIRES_SYMBOLS",
        "REQUIRES_UPPERCASE",
      ],
    },
    aws_cognito_verification_mechanisms: ["EMAIL"],
    aws_user_files_s3_bucket:
      "linkbaseluxoradmin78a5baefca55443f82dd85bbf805c15033-staging",
    aws_user_files_s3_bucket_region: "us-west-2",
  };
  
  export default awsmobile;